export const animals = {
  fox: {
    id: "fox",
    name: "智谋狐狸",
    emoji: "🦊",
    tagline: "反应快、创意强，擅长用巧思破局。",
    strengths: ["创意输出", "适应变化", "多角度思考"],
    tip: "把灵感落成可执行清单，你会更有持续优势。",
    compatibility: [
      { id: "lion", score: 88, reason: "一个想方向，一个推执行，互补很强。" },
      { id: "owl", score: 84, reason: "策略与洞察结合，能看得远也做得快。" },
    ],
  },
  lion: {
    id: "lion",
    name: "领袖狮子",
    emoji: "🦁",
    tagline: "目标感强、推进果断，是天然的带队者。",
    strengths: ["决策推进", "承担责任", "结果导向"],
    tip: "在快节奏推进中，留一点空间听取不同声音。",
    compatibility: [
      { id: "wolf", score: 91, reason: "目标明确且执行稳定，配合效率很高。" },
      { id: "fox", score: 88, reason: "创意和行动结合，适合攻坚突破。" },
    ],
  },
  panda: {
    id: "panda",
    name: "和谐熊猫",
    emoji: "🐼",
    tagline: "温和稳定，重视关系与长期舒适度。",
    strengths: ["共情沟通", "关系协调", "情绪稳定"],
    tip: "当你表达边界和需求时，别人会更懂得珍惜你。",
    compatibility: [
      { id: "dolphin", score: 90, reason: "都擅长连接人，社交体验轻松顺畅。" },
      { id: "owl", score: 80, reason: "一个重情感一个重理性，沟通时很互补。" },
    ],
  },
  owl: {
    id: "owl",
    name: "睿智猫头鹰",
    emoji: "🦉",
    tagline: "理性观察者，擅长在复杂信息中找规律。",
    strengths: ["逻辑分析", "洞察趋势", "深度思考"],
    tip: "适当加快行动频率，能把你的判断更快变成成果。",
    compatibility: [
      { id: "fox", score: 84, reason: "思考深度和创意速度配合自然。" },
      { id: "ant", score: 83, reason: "前者定方向，后者稳落地，长期性强。" },
    ],
  },
  leopard: {
    id: "leopard",
    name: "敏锐猎豹",
    emoji: "🐆",
    tagline: "反应灵敏、执行迅捷，擅长在变化中抢占先机。",
    strengths: ["高效执行", "临场应变", "目标冲刺"],
    tip: "速度是优势，也别忘了给复盘和沉淀留时间。",
    compatibility: [
      { id: "lion", score: 89, reason: "一位定方向，一位提速度，攻坚力很强。" },
      { id: "fox", score: 82, reason: "策略和行动形成闭环，效率与质量兼顾。" },
    ],
  },
  wolf: {
    id: "wolf",
    name: "忠诚灰狼",
    emoji: "🐺",
    tagline: "执行稳健、可信赖，关键时刻从不掉链子。",
    strengths: ["执行落地", "团队协作", "抗压韧性"],
    tip: "主动展示你的想法，会让你的影响力进一步放大。",
    compatibility: [
      { id: "lion", score: 91, reason: "职责清晰、配合高效，稳中有进。" },
      { id: "panda", score: 79, reason: "一个稳定执行，一个协调关系，氛围友好。" },
    ],
  },
  dolphin: {
    id: "dolphin",
    name: "社交海豚",
    emoji: "🐬",
    tagline: "乐观外向，能快速连接人和机会。",
    strengths: ["社交连接", "氛围带动", "沟通表达"],
    tip: "给自己留出独处充电时间，状态会更稳更久。",
    compatibility: [
      { id: "panda", score: 90, reason: "互动轻松，情绪价值高，彼此舒服。" },
      { id: "fox", score: 78, reason: "点子多、节奏快，合作常有新鲜感。" },
    ],
  },
  bird: {
    id: "bird",
    name: "自由飞鸟",
    emoji: "🐦",
    tagline: "热爱探索与表达，靠灵感和新鲜感不断前进。",
    strengths: ["创意探索", "开放包容", "自我驱动"],
    tip: "给自由加一点结构，你的产出会更稳定更可持续。",
    compatibility: [
      { id: "fox", score: 87, reason: "两者都爱新点子，合作时常有惊喜。" },
      { id: "squirrel", score: 80, reason: "一起探索生活乐趣，互动轻松自然。" },
    ],
  },
  ant: {
    id: "ant",
    name: "务实蚂蚁",
    emoji: "🐜",
    tagline: "细致自律，善于把大目标拆解成日常进度。",
    strengths: ["规划管理", "细节把控", "长期坚持"],
    tip: "偶尔允许试错和弹性，你会更轻松地保持高效率。",
    compatibility: [
      { id: "owl", score: 83, reason: "逻辑规划配合严谨执行，成果稳定。" },
      { id: "wolf", score: 81, reason: "两者都重责任感，协作可靠。" },
    ],
  },
  cat: {
    id: "cat",
    name: "神秘黑猫",
    emoji: "🐈‍⬛",
    tagline: "直觉敏锐、感受细腻，擅长在安静中看见本质。",
    strengths: ["直觉洞察", "审美敏感", "独立思考"],
    tip: "把感受写下来并行动一点点，能有效降低内耗。",
    compatibility: [
      { id: "owl", score: 82, reason: "理性与直觉互补，深度交流很有共鸣。" },
      { id: "dog", score: 78, reason: "一个细腻感知，一个稳定守护，关系安心。" },
    ],
  },
  squirrel: {
    id: "squirrel",
    name: "欢乐松鼠",
    emoji: "🐿️",
    tagline: "乐观积极、热爱生活，擅长把日子过得有趣有料。",
    strengths: ["情绪感染力", "机会感知", "生活经营"],
    tip: "保持快乐的同时，明确优先级会让你更从容。",
    compatibility: [
      { id: "dolphin", score: 86, reason: "都擅长带动氛围，社交场景很合拍。" },
      { id: "bird", score: 80, reason: "新鲜感与行动力并存，互动常有火花。" },
    ],
  },
  dog: {
    id: "dog",
    name: "守护犬",
    emoji: "🐕",
    tagline: "忠诚可靠、富有同理心，是团队和关系里的定心石。",
    strengths: ["责任感强", "关系维护", "稳定支持"],
    tip: "在照顾他人的同时，也记得优先照顾好自己的能量。",
    compatibility: [
      { id: "panda", score: 88, reason: "都重视关系与信任，相处稳定温暖。" },
      { id: "wolf", score: 84, reason: "责任感一致，合作时非常可靠。" },
    ],
  },
};
